import { IAction } from '../apiMiddleware'
import { IAtlasPreviewTarget } from '../atlasPreview/actions'
import * as actions from './actions'

export interface IAtlasModulePanelState {
  /** The record asked for. The host may hold the previous one on screen until unsaved edits are settled. */
  target: IAtlasPreviewTarget | null
  /** Bumped on each edit made in the panel; kept across closes so watchers only see real edits. */
  changeCount: number
}

const initialState: IAtlasModulePanelState = {
  target: null,
  changeCount: 0,
}

const atlasModulePanel = (
  state: IAtlasModulePanelState = initialState,
  action: IAction<IAtlasPreviewTarget>,
): IAtlasModulePanelState => {
  switch (action.type) {
    case actions.OPEN_ATLAS_MODULE_PANEL:
      return { ...state, target: action.data ?? null }

    case actions.CLOSE_ATLAS_MODULE_PANEL:
      return { ...state, target: null }

    case actions.ATLAS_MODULE_PANEL_RECORD_CHANGED:
      return { ...state, changeCount: state.changeCount + 1 }

    default:
      return state
  }
}

export default atlasModulePanel
